export function getCurrency(num) {
    if (isNaN(num)) return '-';

    const options = {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    };
    return '$' + Number(num).toLocaleString('en', options);
}

export const blurCurrency = e => {
    e.target.value = e.target.valueAsNumber.toFixed(2);
}

export function getShortDate(date) {
    if (!date) return null;
    return ('00' + (date.getMonth() + 1)).slice(-2) + '/' + ('00' + date.getDate()).slice(-2) + '/' + date.getFullYear();
}

export function getShortUTCDate(date) {
    if (!date) return null;
    return ('00' + (date.getUTCMonth() + 1)).slice(-2) + '/' + ('00' + date.getUTCDate()).slice(-2) + '/' + date.getUTCFullYear();
}

export function getInputDate(date) {
    if (!date) return null;
    return date.getFullYear() + '-' + ('00' + (date.getMonth() + 1)).slice(-2) + '-' + ('00' + date.getDate()).slice(-2);
}

export function addDaysToDateTime(dateTime, days) {
    dateTime.setDate(dateTime.getDate() + days);
    return dateTime;
}

export function addHoursToDateTime(dateTime, hours) {
    dateTime.setTime(dateTime.getTime() + (hours * 60 * 60 * 1000));
    return dateTime;
}

export function addMinutesToDateTime(dateTime, minutes) {
    dateTime.setTime(dateTime.getTime() + (minutes * 60 * 1000));
    return dateTime;
}

export function maskNumberString(str, retainNum, replaceChar) {
    if (!str) return '';
    let regex = new RegExp(`\\d(?=\\d{${retainNum}})`, 'g')
    return str.replace(regex, replaceChar)
}

export const closeMenus = () => {
    [...document.getElementsByClassName('action-dropdown-active')].forEach(el => {
        el.classList.remove('action-dropdown-active');
    });
}

export const toggleOptionsMenu = (e) => {
    e.stopPropagation();
    const isOpen = e.currentTarget.classList.contains('action-dropdown-active');
    closeMenus();
    if (!isOpen)
        e.currentTarget.classList.add('action-dropdown-active');
}

export function validateString(str, props) {
    if (str === null && props.nullable)
        return true;

    if (!props.nullable && !str)
        return false;

    if (props.maxLength != undefined && str.length > props.maxLength)
        return false;

    if (props.minLength != undefined && str.length < props.minLength)
        return false;

    return true;
}

export function handleUnhandledRejection(err) {
    console.log(err);
}

export function toQueryString(paramsObject) {
    if (!paramsObject) return '';

    return Object
        .keys(paramsObject)
        .map(key => {
            if (Array.isArray(paramsObject[key])) {
                return paramsObject[key].map(o => `${encodeURIComponent(key)}=${encodeURIComponent(o)}`).join('&');
            } else {
                return `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
            }
        }).join('&');
}

export async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export const usStates = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
];

export const store = {
    accounts: [
        {
            id: 5,
            active: true,
            accountNumber: 'INV000023',
            name: 'Verizon',
            contactFirst: 'John',
            contactLast: 'Smith',
            email: 'john.smith@verizon.com',
            address: '123 2nd St',
            city: 'Aberdeen',
            state: 'SD',
            zip: '57401',
            balance: 1200.00
        }, {
            id: 6,
            active: false,
            accountNumber: 'INV000024',
            name: 'Warren Fees',
            contactFirst: 'Warren',
            contactLast: 'Wegenke',
            email: 'warren.wegenke@state.sd.us',
            address: '4100 S Broadband Ave',
            city: 'Sioux Falls',
            state: 'SD',
            zip: '57108',
            balance: 4897760.99
        }, {
            id: 7,
            active: true,
            accountNumber: 'INV000025',
            name: 'Account',
            contactFirst: 'First',
            contactLast: 'Last',
            email: 'first.last@account.com',
            address: '321 E 3rd St',
            city: 'Pierre',
            state: 'SD',
            zip: '57501',
            balance: 20.00
        }
    ],
    fees: [
        {
            id: 1,
            identifier: 'SD0000001',
            facility: 'Verizon (Aberdeen)',
            description: 'This is a test fee. Adding additional text just to make the description longer to see how it will appear.',
            amount: 600.00,
            dueDate: new Date('07/31/2020'),
            accountId: 5,
            divisionId: 1,
            division: {
                name: "Air Quality"
            },
            feePlanId: null,
            paidInFull: false,
            paid: 400.00,
            due: 200.00
        },
        {
            id: 2,
            identifier: 'SD0000002',
            facility: 'Verizon (Aberdeen)',
            description: 'This is another test fee.',
            amount: 600.00,
            dueDate: new Date('07/31/2019'),
            accountId: 5,
            divisionId: 2,
            division: {
                name: "Drinking Water"
            },
            feePlanId: null,
            paidInFull: true,
            paid: 600.00,
            due: 0.00
        }
    ],
    feePayments: [
        {
            feeId: 1,
            paymentId: 1,
            amount: 200
        },
        {
            feeId: 2,
            paymentId: 1,
            amount: 200
        },
        {
            feeId: 1,
            paymentId: 2,
            amount: 200
        },
        {
            feeId: 1,
            paymentId: 3,
            amount: 200
        },
        {
            feeId: 2,
            paymentId: 4,
            amount: 600
        }
    ],
    payments: [
        {
            id: 1,
            success: true,
            amount: 400,
            paidDate: new Date('07/28/2019'),
            type: {
                id: 1,
                name: "Credit Card"
            },
            transactionId: "194ed155",
            feePayments: [
                {
                    feeId: 1,
                    paymentId: 1,
                    amount: 200,
                    fee: {
                        id: 1,
                        identifier: 'SD0000001',
                        facility: 'Verizon (Aberdeen)',
                        description: 'This is a test fee. Adding additional text just to make the description longer to see how it will appear.',
                        amount: 600.00,
                        dueDate: new Date('07/31/2020'),
                        accountId: 5,
                        divisionId: 1,
                        division: {
                            name: "Air Quality"
                        },
                        feePlanId: null,
                        paidInFull: false,
                        paid: 400.00,
                        due: 200.00,
                        account: {
                            id: 5,
                            active: true,
                            accountNumber: 'INV000023',
                            name: 'Verizon',
                            contactFirst: 'John',
                            contactLast: 'Smith',
                            email: 'john.smith@verizon.com',
                            address: '123 2nd St',
                            city: 'Aberdeen',
                            state: 'SD',
                            zip: '57401',
                            balance: 1200.00
                        }
                    }
                },
                {
                    feeId: 2,
                    paymentId: 1,
                    amount: 200,
                    fee: {
                        id: 2,
                        identifier: 'SD0000002',
                        facility: 'Verizon (Aberdeen)',
                        description: 'This is another test fee.',
                        amount: 600.00,
                        dueDate: new Date('07/31/2019'),
                        accountId: 5,
                        divisionId: 2,
                        division: {
                            name: "Drinking Water"
                        },
                        feePlanId: null,
                        paidInFull: true,
                        paid: 600.00,
                        due: 0.00,
                        account: {
                            id: 5,
                            active: true,
                            accountNumber: 'INV000023',
                            name: 'Verizon',
                            contactFirst: 'John',
                            contactLast: 'Smith',
                            email: 'john.smith@verizon.com',
                            address: '123 2nd St',
                            city: 'Aberdeen',
                            state: 'SD',
                            zip: '57401',
                            balance: 1200.00
                        }
                    }
                }
            ]
        },
        {
            id: 2,
            success: false,
            amount: 200,
            paidDate: new Date('07/21/2019'),
            type: {
                id: 2,
                name: "ACH"
            },
            transactionId: "6cc69b86",
            feePayments: [
                {
                    feeId: 1,
                    paymentId: 2,
                    amount: 200,
                    fee: {
                        id: 1,
                        identifier: 'SD0000001',
                        facility: 'Verizon (Aberdeen)',
                        description: 'This is a test fee. Adding additional text just to make the description longer to see how it will appear.',
                        amount: 600.00,
                        dueDate: new Date('07/31/2020'),
                        accountId: 5,
                        divisionId: 1,
                        division: {
                            name: "Air Quality"
                        },
                        feePlanId: null,
                        paidInFull: false,
                        paid: 400.00,
                        due: 200.00,
                        account: {
                            id: 5,
                            active: true,
                            accountNumber: 'INV000023',
                            name: 'Verizon',
                            contactFirst: 'John',
                            contactLast: 'Smith',
                            email: 'john.smith@verizon.com',
                            address: '123 2nd St',
                            city: 'Aberdeen',
                            state: 'SD',
                            zip: '57401',
                            balance: 1200.00
                        }
                    }
                }
            ]
        },
        {
            id: 3,
            success: false,
            amount: 200,
            paidDate: new Date('07/10/2019'),
            type: {
                id: 3,
                name: "Check"
            },
            transactionId: null,
            feePayments: [
                {
                    feeId: 1,
                    paymentId: 3,
                    amount: 200,
                    fee: {
                        id: 1,
                        identifier: 'SD0000001',
                        facility: 'Verizon (Aberdeen)',
                        description: 'This is a test fee. Adding additional text just to make the description longer to see how it will appear.',
                        amount: 600.00,
                        dueDate: new Date('07/31/2020'),
                        accountId: 5,
                        divisionId: 1,
                        division: {
                            name: "Air Quality"
                        },
                        feePlanId: null,
                        paidInFull: false,
                        paid: 400.00,
                        due: 200.00,
                        account: {
                            id: 5,
                            active: true,
                            accountNumber: 'INV000023',
                            name: 'Verizon',
                            contactFirst: 'John',
                            contactLast: 'Smith',
                            email: 'john.smith@verizon.com',
                            address: '123 2nd St',
                            city: 'Aberdeen',
                            state: 'SD',
                            zip: '57401',
                            balance: 1200.00
                        }
                    }
                }
            ]
        },
        {
            id: 4,
            success: true,
            amount: 600,
            paidDate: new Date('07/29/2020'),
            type: {
                id: 1,
                name: "Credit Card"
            },
            transactionId: "179ah76b",
            feePayments: []
        }
    ],
    divisions: [
        {
            id: 1,
            name: 'Air Quality'
        },
        {
            id: 2,
            name: 'Drinking Water'
        },
        {
            id: 3,
            name: 'Surface Water'
        },
        {
            id: 7,
            name: 'Stormwater Construction'
        },
        {
            id: 6,
            name: 'NPDES Munincipal'

        },
        {
            id: 4,
            name: 'Stormwater Industrial'
        }

        
    ],
    roles: [
        {
            id: 1,
            name: 'Admin',
            users: [
                {
                    id: 2,
                    email: 'andrew.pedersen@state.sd.us'
                }
            ]
        },
        {
            id: 2,
            name: 'Editor',
            users: [
                {
                    id: 3,
                    email: 'eric.davis@state.sd.us'
                }
            ]
        },
        {
            id: 3,
            name: 'Viewer',
            users: [
                {
                    id: 2,
                    email: 'andrew.pedersen@state.sd.us'
                },
                {
                    id: 1,
                    email: 'warren.wegenke@state.sd.us'
                }
            ]
        }
    ],
    users: [
        {
            id: 1,
            email: 'warren.wegenke@state.sd.us',
            roles: [
                {
                    id: 3,
                    name: 'Viewer'
                }
            ]
        },
        {
            id: 2,
            email: 'andrew.pedersen@state.sd.us',
            roles: [
                {
                    id: 1,
                    name: 'Admin'
                },
                {
                    id: 3,
                    name: 'Viewer'
                }
            ]
        },
        {
            id: 3,
            email: 'eric.davis@state.sd.us',
            roles: [
                {
                    id: 2,
                    name: 'Editor'
                }
            ]
        }
    ],
    roleUsers: [
        {
            roleId: 3,
            userId: 1
        },
        {
            roleId: 2,
            userId: 3
        },
        {
            roleId: 1,
            userId: 2
        },
        {
            roleId: 3,
            userId: 2
        }
    ]
}